import { IRbacBusinessUnit } from '@dxp/core/models';

export const toBusinessUnitRecord = (
    units: IRbacBusinessUnit[],
): Record<string, IRbacBusinessUnit> => {
    const record: Record<string, IRbacBusinessUnit> = {};

    for (const unit of units) {
        record[unit.id] = unit;
    }

    return record;
};

export const businessUnitRecordsEqual = (
    a: Record<string, IRbacBusinessUnit>,
    b: Record<string, IRbacBusinessUnit>,
): boolean => {
    if (a === b) return true;

    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    for (const key of aKeys) {
        const au = a[key];
        const bu = b[key];

        if (!bu) return false;

        if (au.id !== bu.id || au.name !== bu.name) {
            return false;
        }
    }

    return true;
};
